<template>
  <div class="notfound">
    <h2>页面不存在</h2>
    <p>你访问的地址可能已被移动或删除。</p>
    <el-button type="primary" @click="$router.push('/')">返回首页</el-button>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>

<style scoped>
.notfound{
  width: 100%;
  padding: 40px 10px;
  box-shadow: 0 0 5px 1px #999;
  border-radius: 10px;
}
</style>

